var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 0.874762C12.5516 1.02589 12.9853 1.4712 13.1325 2.03671C13.4 3.06162 13.4 5.2001 13.4 5.2001C13.4 5.2001 13.4 7.3385 13.1325 8.36349C12.9853 8.92899 12.5516 9.3743 12.0008 9.52551C11.0027 9.8001 7.00001 9.8001 7.00001 9.8001C7.00001 9.8001 2.99732 9.8001 1.99913 9.52551C1.44837 9.3743 1.01462 8.92899 0.867424 8.36349C0.600006 7.3385 0.600006 5.2001 0.600006 5.2001C0.600006 5.2001 0.600006 3.06162 0.867424 2.03671C1.01462 1.4712 1.44837 1.02589 1.99913 0.874762C2.99732 0.600098 7.00001 0.600098 7.00001 0.600098C7.00001 0.600098 11.0027 0.600098 12.0008 0.874762ZM5.80002 3.40006V7.40006L9.00002 5.40013L5.80002 3.40006Z",
    fill: "#479ED7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath1);
export default __webpack_public_path__ + "static/media/Path (1).c6ba80625af25d38b2cc9fdbac7b01d6.svg";
export { ForwardRef as ReactComponent };